/** @ignore *//** */
const config = {
  version: '2.16.2',
  type: 'js'
};

export default config;